import Header from "./components/header";

const moduleMap = {
	'.faq-element':            () => import('./elements/faq'),
	'.gallery-element':        () => import('./elements/gallery'),
	'.hero-element':           () => import('./elements/hero'),
	'.instagram-feed-element': () => import('./elements/instagram-feed'),
	'.offers-element':         () => import('./elements/offers'),
	'.properties-element':     () => import('./elements/properties'),
	'.property-map-element':   () => import('./elements/property-map'),
	'.tiles-element':          () => import('./elements/tiles'),
	'.things-to-do-element':   () => import('./elements/things-to-do'),
	'.rooms-element':          () => import('./elements/rooms'),

	'.increment-control':      () => import('./components/increment-control'),
	'.search-element':         () => import('./components/search'),
	'.userform':               () => import('./components/floating-labels'),
};

/** @type {Configuration} */
const configuration = {
	containerBreakpoints: {
		sm: 540,
		md: 720,
		lg: 960,
		xl: 1140,
		xxl: 1600,
	},
};

new Header();

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (!entry.isIntersecting) {
			return;
		}
		for (const [selector, load] of Object.entries(moduleMap)) {
			if (entry.target.matches(selector)) {
				load().then(m => new m.default(entry.target, configuration));
				observer.unobserve(entry.target);
				break;
			}
		}
	});
}, {rootMargin: '200px'});

document.querySelectorAll(Object.keys(moduleMap).join(','))
	.forEach(el => observer.observe(el));


// Only show Myma widget on desktop due to interference with RoomStay widget
const mymaSource = document.getElementById('myma-widget-source');
if (mymaSource) {
	if (window.matchMedia('(min-width: 768px)').matches) {
		const content = document.importNode(mymaSource.content, true);
		content.querySelectorAll('script').forEach(oldScript => {
			const newScript = document.createElement('script');
			for (const attr of oldScript.attributes) {
				newScript.setAttribute(attr.name, attr.value);
			}
			newScript.textContent = oldScript.textContent;
			oldScript.replaceWith(newScript);
		});
		document.body.appendChild(content);
	}
	mymaSource.remove();
}


// Dynamically load RoomStay scripts as <% require javascript() %> is not cacheable
const roomStayContainers = [
	'roomstay-inline-container',
	'roomstay-wizard-container',
	'roomstay-recent-container'
];
for (let i = 0; i < roomStayContainers.length; i++) {
	const element = document.getElementById(roomStayContainers[i]);
	if (!element || !element.dataset.js) {
		continue;
	}
	const script = document.createElement('script');
	script.src = element.dataset.js;
	script.async = true;
	document.body.appendChild(script);
}


